export default __webpack_public_path__ + "static/media/logo-tributo.bdd0d170.png";